"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const react_1 = __importStar(require("react"));
/**
 * This component provides a hover parameter to its child render function, which
 * is true when the pointer hovers over this component.
 *
 * @todo Finish the cloneElement typings and preserve the children's original
 *   onMouseEnter and onMouseLeave handlers.
 *
 * @todo Investigate alternatives, such as providing an onHover callback instead
 *   of using a child render function, or creating a useHover hook instead.
 */


const Hover = props => {
  const [hover, setHover] = react_1.useState(false);
  const onMouseEnter = react_1.useCallback(() => {
    setHover(true);
  }, []);
  const onMouseLeave = react_1.useCallback(() => {
    setHover(false);
  }, []);
  return react_1.default.createElement(react_1.Fragment, null, react_1.default.Children.map(props.children(hover), child => react_1.default.cloneElement(child, {
    onMouseEnter: event => {
      onMouseEnter(); // child.onMouseEnter(event)
    },
    onMouseLeave: event => {
      onMouseLeave(); // child.onMouseLeave(event)
    }
  })));
};

exports.default = Hover;